import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { TipoPersona } from '../interface/TipoPersonaInterface';
import { Token } from '../../../../interface/Token';
import { TipoDocumentos } from '../interface/TipoDocumentoInterface';
import { TipoIibb } from '../interface/TipoIIBBInterface';
import { TipoIva } from '../interface/TipoIva';
import { Descripcion, Especialidades } from '../interface/Especialidades';
import { SumaAsegurada } from '../interface/SumaAsegurada';
import { Provincias } from "../interface/Provincias";
import { Localidades } from "../interface/Localidades";

import { environment } from '../../../../../environments/environment';
import { Cotizacion } from '../interface/Cotizacion';
import { FormaPago } from '../interface/FormaPago';
import { Tarjetas } from '../interface/Tarjetas';
import { Sexo } from '../interface/sexo';
import { CuitCuil } from '../interface/cuit';
import { Documento } from '../interface/Documento';
import { Matriculas } from '../interface/matriculas';


@Injectable({
  providedIn: 'root'
})
export class PraxisService {

  //private apiUrl: string = 'https://productores.argbroker.com.ar'

  private apiUrl: string = environment.apiPlataforma;



  constructor(private http: HttpClient) { }
/*
  getToken (usuario: string, password: string): Observable<Token>{
    const url = `${this.apiUrl}/auth/login`;

    const dataToSend = {
      email: usuario,
      password: password
    }

    return this.http.post<Token>(url, dataToSend);

  }
    */

  getTipoPersona (token: string): Observable<TipoPersona[]>{
    const url = `${this.apiUrl}/api/v1/medind/tipopersona`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    return this.http.post<TipoPersona[]>(url, '', options);

  }

  getFormaPago(token: string): Observable<FormaPago[]>{
    const url = `${this.apiUrl}/api/v1/medind/formapago`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    const dataToSend = {
      origen: '1',
    }

    return this.http.post<TipoDocumentos[]>(url, dataToSend, options);
  }

  getTarjetas(token: string): Observable<Tarjetas[]>{
    const url = `${this.apiUrl}/api/v1/medind/tarjetas`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    return this.http.post<Tarjetas[]>(url, '', options);
  }

  getSexo(token: string): Observable<Sexo[]>{
    const url = `${this.apiUrl}/api/v1/medind/sexo`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    return this.http.post<Sexo[]>(url, '', options);
  }

  getCuit(token: string, dni: string, sexo: string): Observable<CuitCuil>{
    const url = `${this.apiUrl}/api/cuit`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    const dataToSend = {
      dni: dni,
      sexo: sexo
    }

    return this.http.post<CuitCuil>(url, dataToSend, options);
  }


  getTipoDocumento(token: string): Observable<TipoDocumentos[]>{
    const url = `${this.apiUrl}/api/v1/medind/tipodocumento`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    return this.http.post<TipoDocumentos[]>(url, '', options);
  }

  getIngresosBrutos(token: string): Observable<TipoIibb[]>{
    const url = `${this.apiUrl}/api/v1/medind/iibb`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = { headers: headers };

    return this.http.post<TipoIibb[]>(url, '', options);
  }

  getIva(token: string, valor: string, disponible: string): Observable<TipoIva[]>{
    const url = `${this.apiUrl}/api/v1/medind/iva`;

    const dataToSend = {
      documento: valor,
      disponible: disponible
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,

    });

    const options = { headers: headers };

    return this.http.post<TipoIva[]>(url, dataToSend, options);
  }

  getCorrespondeDocumento(token:string, iva: string): Observable<Documento[]>{
    const url = `${this.apiUrl}/api/v1/medind/corresponde_documento`;


    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,

    });

    const dataToSend = {
      condicion: iva
    }

    const options = { headers: headers };
    return this.http.post<Documento[]>(url, dataToSend, options);
  }

  getEspecialidades(token: string, query: string): Observable<Especialidades[]>{
    const url = `${this.apiUrl}/api/v1/medind/especialidades`;


    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,

    });

    const dataToSend = {
      q: query
    }

    const options = { headers: headers };
    return this.http.post<Especialidades[]>(url, dataToSend, options);
  }

  getVeterinarios(token: string): Observable<Descripcion[]>{
    const url = `${this.apiUrl}/api/v1/medind/especialidades_descripcion`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,

    });


    const options = { headers: headers };
    return this.http.post<Descripcion[]>(url, null, options);
  }


  getSumaAsegurada(token: string, query: string): Observable<SumaAsegurada>{
    const url = `${this.apiUrl}/api/v1/medind/sa_categoria`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });

    const dataToSend = {
      especialidad: query
    }

    const options = {
      headers: headers
    }

    return this.http.post<SumaAsegurada>(url, dataToSend, options);
  }

  getSumaAsegurada_veterinario(token: string, query: string): Observable<SumaAsegurada>{
    const url = `${this.apiUrl}/api/v1/medind/sa_veterinario`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });

    const dataToSend = {
      especialidad: query
    }

    const options = {
      headers: headers
    }

    return this.http.post<SumaAsegurada>(url, dataToSend, options);
  }

  getProvincias(token: string): Observable<Provincias[]>{
    const url = `${this.apiUrl}/api/provincias`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });


    const options = {
      headers: headers
    }

    return this.http.post<Provincias[]>(url, null, options);

  }

  getLocalidades(token: string, cp: string): Observable<Localidades[]>{
    const url = `${this.apiUrl}/api/localidades`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });

    const dataToSend = {
      cp: cp
    }

    const options = {
      headers: headers
    }

    return this.http.post<Localidades[]>(url, dataToSend, options);
  }

  getMatriculas(token: string): Observable<Matriculas[]>
  {
    const url = `${this.apiUrl}/api/v1/medind/tipo_matricula`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });


    const options = {
      headers: headers
    }

    return this.http.post<Matriculas[]>(url, null, options);
  }

  getCotizarSolicitar(token: string | null,
                      uuid: any,
                      ramo: string | null,
                      solicitar: string | null = 'false',
                      conducto_pago: string | null,
                      iibb: string | null,
                      iva: string | null,
                      tipo_persona: string | null = 'F',
                      cod_matricula: string | null = '',
                      matricula: string | null,
                      codigo_especialidad: string | null,
                      titulo: string | null,
                      suma_asegurada: string | null,
                      apellido: string | null,
                      nombre: string | null,
                      cod_postal: string | null = '',
                      calle: string | null = '',
                      altura: string | null = '',
                      tipo_documento: string | null = '1',
                      numero_documento: string | null = '',
                      celular: string | null,
                      email: string | null,

                      tarjeta_cbu: string | null,
                      sexo: string | null = '',
                      vigencia: string | null = '',
                      jefe: string | null = '',
                      director: string | null  = ''

                      ): Observable<Cotizacion>{
    const url = `${this.apiUrl}/api/v1/medind/cotizar_solicitar`

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });

    const dataToSend = {
      uuid: uuid,
      solicitar: solicitar,
      ramo: ramo,
      conducto_pago: conducto_pago,
      iibb: iibb,
      iva: iva,
      tipo_persona: tipo_persona,
      matricula: matricula,
      codigo_especialidad: codigo_especialidad,
      titulo: titulo,
      suma_asegurada: suma_asegurada,
      apellido: apellido,
      nombre: nombre,
      cod_postal: cod_postal,
      calle: calle,
      altura: altura,
      tipo_documento: tipo_documento,
      numero_documento: numero_documento,
      celular: celular,
      email: email,
      tarjeta_cbu: tarjeta_cbu,
      sexo: sexo,
      vigencia_desde: vigencia,
      jefe: jefe,
      director: director,
      cod_matricula: cod_matricula
    }

    const options = {
      headers: headers
    }

    return this.http.post<Cotizacion>(url, dataToSend, options);
  }

}
